<template>
  <footer class="footerComponents">
      <img src="@/assets/img/logo.png">
    </footer>
</template>

<script>
  export default {
    name: 'footerComponents',
    props: {},
    data() {
      return {}
    },
    methods: {},
    watch: {},
    created: function () {},
    mounted: function () {},
  }
</script>
<style lang="scss">
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->